import { jsx as _jsx, jsxs as _jsxs } from "preact/jsx-runtime";
import { useLocation } from 'preact-iso';
import { getWebTypeMeta } from '@/constants/webTypes';
import { LeadGoalBar } from '@/components';
import { formatDateOnly } from '@/utils/dateTimeFormatters';
import { shortAgo } from '@/utils/time';
import { routes } from '@/utils/routes';
export function CampaignWebsCardView({ webs, campaignId, workspaceId, clientCompanyId }) {
    const location = useLocation();
    const getLaunchText = (launchDate) => {
        if (!launchDate)
            return 'Launch —';
        // Get today's date as YYYY-MM-DD in local time
        const today = new Date();
        const todayStr = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}-${String(today.getDate()).padStart(2, '0')}`;
        if (launchDate === todayStr) {
            return 'Launch is today';
        }
        else if (launchDate < todayStr) {
            return `Launched ${formatDateOnly(launchDate)}`;
        }
        else {
            return `Launch is ${formatDateOnly(launchDate)}`;
        }
    };
    const Card = ({ item }) => {
        const tone = 'bg-white dark:bg-slate-800 text-slate-800 dark:text-slate-200 border-slate-200 dark:border-slate-700';
        // Map WebType to icon/label
        const typeMeta = getWebTypeMeta(item.WebType);
        const Icon = typeMeta.Icon;
        const chipClass = typeMeta.chipClass;
        const displayLabel = item.WebType.trim();
        const goal = Math.max(0, item.LeadGoal || 0);
        const leads = Math.max(0, item.LeadsCount || 0);
        const url = routes.scoped(clientCompanyId, workspaceId).web(campaignId, item.Id);
        const open = () => location.route(url);
        return (_jsx("div", { role: "button", tabIndex: 0, onClick: open, onKeyDown: (e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    open();
                }
            }, className: `rounded-xl border p-4 shadow-sm hover:shadow-md transition-all w-full text-left cursor-pointer focus:outline-none focus:ring-2 focus:ring-primary-500 ${tone}`, children: _jsx("div", { children: _jsxs("div", { className: "flex-1 min-w-0", children: [_jsx("div", { className: "mb-2", children: _jsxs("span", { className: `inline-flex items-center gap-1 px-2 py-0.5 text-sm font-semibold rounded-full ${chipClass}`, children: [_jsx(Icon, { className: "w-4 h-4" }), displayLabel] }) }), _jsx("h3", { className: "text-sm md:text-base font-semibold truncate mb-2", children: item.Title }), _jsxs("div", { className: "mt-1", children: [_jsxs("div", { className: "flex items-center justify-between text-xs md:text-sm mb-1", children: [_jsx("span", { className: "text-slate-500 dark:text-slate-400", children: "Leads generated" }), _jsxs("span", { className: "font-medium", children: [leads.toLocaleString(), " / ", goal.toLocaleString()] })] }), _jsx(LeadGoalBar, { sourced: leads, goal: goal, mode: "card" })] }), _jsxs("div", { className: "mt-3 flex items-center justify-between text-xs md:text-sm text-slate-500 dark:text-slate-400", children: [_jsx("span", { children: getLaunchText(item.LaunchDate) }), _jsx("span", { children: item.LastLeadCreatedDate ? shortAgo(item.LastLeadCreatedDate) : 'No leads' })] })] }) }) }));
    };
    return (_jsx("div", { className: "grid gap-4 grid-cols-1 sm:grid-cols-2 lg:grid-cols-3", children: webs.map(web => (_jsx(Card, { item: web }, web.Id))) }));
}
